export const MISC_ACTIONS = {
  SET_SSE_ONLNE: "MISC_SET_SSE_ONLINE",
};

export const miscState__setSseOnline = (sseOnline) => ({
  type: MISC_ACTIONS.SET_SSE_ONLNE,
  sseOnline,
});
